interface ResolvePendingAutoSubmitArgs {
  pendingPrompt: string | null;
  promptDraft: string;
  isStreaming: boolean;
}

interface PendingAutoSubmitResolution {
  nextPendingPrompt: string | null;
  shouldAutoSubmit: boolean;
}

export const resolvePendingAutoSubmit = ({
  pendingPrompt,
  promptDraft,
  isStreaming,
}: ResolvePendingAutoSubmitArgs): PendingAutoSubmitResolution => {
  const normalizedPendingPrompt = pendingPrompt?.trim() || null;
  const normalizedPromptDraft = promptDraft.trim();

  if (!normalizedPendingPrompt || isStreaming) {
    return {
      nextPendingPrompt: normalizedPendingPrompt,
      shouldAutoSubmit: false,
    };
  }

  if (!normalizedPromptDraft) {
    return {
      nextPendingPrompt: normalizedPendingPrompt,
      shouldAutoSubmit: false,
    };
  }

  if (normalizedPromptDraft !== normalizedPendingPrompt) {
    return {
      nextPendingPrompt: null,
      shouldAutoSubmit: false,
    };
  }

  return {
    nextPendingPrompt: null,
    shouldAutoSubmit: true,
  };
};
